import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { INSIGHTS_MENU_ITEMS, type InsightsMenuItem } from './navMenuConfig';
import { InsightsMenuIcon } from './NavMenuIcons';
import { slugifyTrackingValue, trackEvent } from '@/utils/analytics';
import type { ReactNode } from 'react';

type InsightsMegaMenuProps = {
  onNavigate: () => void;
};

function trackInsightsClick(label: string, href: string, section = 'top_navigation_mega_insights') {
  trackEvent({
    name: 'navigation_click',
    buttonId: `navigation_insights_${slugifyTrackingValue(href)}`,
    label,
    page: 'global',
    section,
    feature: 'navigation',
    eventCategory: 'navigation',
  });
}

export function InsightsMenuLink({
  item,
  className,
  onClick,
  children,
}: {
  item: InsightsMenuItem;
  className?: string;
  onClick: () => void;
  children: ReactNode;
}) {
  if (item.external) {
    return (
      <a
        href={item.href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${item.label} (opens in a new tab)`}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={item.href} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}

export default function InsightsMegaMenu({ onNavigate }: InsightsMegaMenuProps) {
  return (
    <div className="nav-mega-insights-panel">
      <header className="nav-mega-insights-panel__header">
        <div>
          <p className="nav-mega-section-title">INSIGHTS</p>
          <p className="nav-mega-insights-panel__subtitle">Research, stories and news from DISGENET</p>
        </div>
      </header>

      <ul className="nav-mega-insights">
        {INSIGHTS_MENU_ITEMS.map(item => (
          <li key={item.id}>
            <InsightsMenuLink
              item={item}
              className="nav-mega-docs-item"
              onClick={() => {
                trackInsightsClick(item.label, item.href);
                onNavigate();
              }}
            >
              <span className="nav-mega-docs-item__icon" aria-hidden>
                <InsightsMenuIcon icon={item.icon} />
              </span>
              <span className="nav-mega-docs-item__text">
                <span className="nav-mega-docs-item__title nav-mega-insights-item__title">
                  {item.label}
                  {item.external && (
                    <ArrowTopRightOnSquareIcon className="nav-mega-insights-item__external" aria-hidden />
                  )}
                </span>
                <span className="nav-mega-docs-item__subtitle">{item.subtitle}</span>
              </span>
            </InsightsMenuLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
